export default __webpack_public_path__ + "static/media/img2.3f700831.png";